<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "Rejected Agent List",
      items: [
        {
          text: "Agent",
          href: "/",
        },
        {
          text: "Agent List",
          active: true,
        },
      ],
      agents: [],
        errors:null,
        visible:false,
        message:"",
        search_fname:"",
        search_lname:"",
        search_uname:"",
        search_email:"",
        search_phone:"",
        search_pcode:"",
        search:"",
    };
  },
  mounted() {
    this.getAgentList();
  },
    computed: {
        filteredList() {
            return this.agents.filter(agent => {
                return (agent.users[0].username==null ? '' : agent.users[0].username).toLowerCase().includes(this.search_uname.toLowerCase())
                    && agent.email.toLowerCase().includes(this.search_email.toLowerCase())
            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
      async approveAgent(agent) {
        var _this = this;
        this.agentUuid=agent.uuid;
        this.show=true;

      // if(this.agentApproved==true){
      //     _this.reason = result.value;
      //     _this.approve(agent.id, agent.uuid);
      // }
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          input: "text",
          inputPlaceholder: "Enter your approval remark",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Approve it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.reason = result.value;
            _this.approve(agent.uuid);
          } else {
            this.$swal(
              "Cancelled",
              "Agent approval pending yet. Reason missing",
              "info"
            );
          }
        });
      } catch (err) {
        console.log(err);
      }
      },
    async deleteWarning(agent) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(agent);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getAgentList() {
      try {
        axios
          .get("/api/agent/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                let agents = response.data.data;
                let filteredAgent=[];
                let i;
                let index_no=1;
                for(i=0;i<agents.length;i++){

                    if(agents[i].approval_status== 'rejected'){
                        agents[i].new_index=index_no;
                        filteredAgent.push(agents[i]);
                        index_no++;
                    }
                }
                this.agents=filteredAgent;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      async approve(uuid) {
          var _this = this;
          try {
              axios
                  .put("/api/agent/approve", {
                      accessToken: localStorage.getItem("access_tocken"),
                      approval_remark: _this.reason,
                      uuid: uuid,
                  })
                  .then(function (response) {
                      if (response.data.status) {
                          _this.$swal("Success", "Agent Approved successfully", "success");
                          _this.getAgentList();
                          _this.hasDeleted = false;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          _this.errorCheck(jsonParse);
                      }
                  });
          } catch (err) {
              console.log(err);
          }
      },

    deleteItem: function deleteItem(agent) {
      var _this = this;
      axios
        .post("/api/agent/delete/" + agent.uuid, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
        if (response.data.status){
            _this.$swal.fire({
                position: 'top-end',
                icon: 'error',
                title: 'Successfully Delete Agent',
                showConfirmButton: false,
                timer: 1000
            });
            _this.getAgentList();
            _this.hasDeleted = false;
        }
        });
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                  <thead>
                  <tr>
                      <th>Agent ID</th>
                      <th>
                          <div class="row">
                              <div class="col-xs-4">Login ID</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">Company Name/Balance/loan</div>
                          </div>
                      </th>
                      <th>User/Contact Info </th>
                      <th>Owner Info</th>
                      <th>
                          <div class="row">
                              <div class="col-xs-4">City</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">State/Country</div>
                          </div>

                      </th>
                      <th>Action</th>
                      <!--                      <th>Currency</th>-->
                      <!--                      <th>Language</th>-->
                      <!--                      <th>Balance</th>-->
                      <!--                      <th>Loan</th>-->
                      <!--                      <th>Status</th>-->
                      <!--                      <th></th>-->
                      <!--                    <th>Action</th>-->
                      <!--                      <th></th>-->
                  </tr>
                  <tr>
                      <td> <input type="text" class="app-search form-control" v-model="search_uname" placeholder="Search id" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_email" placeholder="Search email / agency Name" /></td>
                      <!--                    <td><input type="text" class="app-search form-control" v-model="search_phone" placeholder="Search " /></td>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(agent,index) in filteredList" v-bind:key="index">
                      <!--                    <th scope="row">{{agent.new_index}}</th>-->
                      <!--                    <td>{{agent.first_name}}</td>-->
                      <!--                    <td>{{agent.last_name}}</td>-->
                      <td v-if="agent.users!=undefined">{{agent.users[0].username!=null?agent.users[0].username:'N/A'}} <i class="bx bx-x"></i>rejected</td>
                      <td v-else>null</td>
                      <td class="padding-5px-right" v-if="agent.agency_information[0]!=undefined">
                          <div class="row">
                              <div class="col-xs-4">{{agent.email}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"> {{agent.agency_information[0].agency_name}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"> <b-badge variant="success" class="ml-1">{{ agent.users[0].user_wallet!=null ? agent.users[0].user_wallet.currency : 'N/A' }}</b-badge>  <b-badge variant="success" class="ml-1">{{ agent.users[0].user_wallet!=null ? agent.users[0].user_wallet.main_balance : 'N/A' }}</b-badge> <b-badge variant="danger" class="ml-1">{{agent.users[0].user_wallet!=null ? agent.users[0].user_wallet.loan_balance : 'N/A'}}</b-badge></div>
                          </div>
                      </td>
                      <td v-else>N/A</td>

                      <td class="padding-5px-right">
                          <div class="row">
                              <div class="col-xs-4">{{agent.first_name}} {{agent.last_name}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.phone_code}} {{agent.phone_number}}</div>
                          </div>

                      </td>
                      <td class="padding-5px-right" v-if="agent.agency_information[0]!=undefined">
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].management_full_name==null ? 'N/A' : agent.agency_information[0].management_full_name}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].management_phone_number==null ? 'N/A' : agent.agency_information[0].management_phone_number}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].management_email==null ? 'N/A' : agent.agency_information[0].management_email}}</div>
                          </div>
                      </td>
                      <td v-else>N/A</td>
                      <td  class="padding-5px-right"   v-if="agent.agency_information[0]!=undefined">
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].city==null ? 'N/A' : agent.agency_information[0].city}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].address==null ? 'N/A' : agent.agency_information[0].address}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"> {{agent.agency_information[0].country == null ? 'N/A' : agent.agency_information[0].country}}</div>
                          </div>
                      </td>
                      <td v-else>N/A</td>
                      <!--                      <td v-if="agent.users[0].user_wallet!=null">{{ agent.users[0].user_wallet.main_balance }}</td>-->
                      <!--                      <td v-else>0</td>-->
                      <!--                      <td v-if="agent.users[0].user_wallet!=null">{{ agent.users[0].user_wallet.loan_balance }}</td>-->
                      <!--                      <td v-else>0</td>-->
                      <!--                      <td v-if="agent.users!=undefined">{{agent.users[0].status}}</td>-->
                      <!--                      <td v-else >null</td>-->
                      <td>
                          <b-dropdown dropright>
                              <template v-slot:button-content>
                                  Action
                                  <i class="mdi mdi-chevron-down"></i>
                              </template>
                              <b-dropdown-item><button @click.prevent="approveAgent(agent)" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i>Approve</button></b-dropdown-item>
                              <b-dropdown-item><router-link :to="{ name: 'agent_update', params: {type:'reject',uuid: agent.uuid } }" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i> Edit</router-link></b-dropdown-item>
                              <b-dropdown-item><button @click.prevent="deleteWarning(agent)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i> Delete</button></b-dropdown-item>
                          </b-dropdown>
                      </td>
                      <!--                    <td><b-button class="btn btn-primary btn-small"  v-b-modal.modal-lg variant="primary" @click.prevent="getAgentDetails(agent)">Details</b-button></td>-->
                      <!--                      <td><router-link :to="{ name: 'agent_update', params: {type:'approve',uuid: agent.uuid}}" class="btn btn-primary btn-small"> Edit</router-link></td>-->
                      <!--                      <td  align='center'><button v-if="agent.users[0].status=='active'" class="btn btn-primary btn-small" @click.prevent="userStatusWarning(agent.users[0].uuid)">Deactivate</button><button style="width:100%" v-else class="btn btn-primary btn-small" @click.prevent="userStatusWarning(agent.users[0].uuid)">Activate</button></td>-->
                  </tr>
                  </tbody>
<!--                <tbody>-->
<!--                  <tr v-for="(agent,index) in filteredList" v-if="agent.approval_status == 'rejected'" v-bind:key="index">-->
<!--                    <th scope="row">{{agent.new_index}}</th>-->
<!--                    <td>{{agent.first_name}}</td>-->
<!--                    <td>{{agent.last_name}}</td>-->
<!--                      <td v-if="agent.users[0].username!=null">{{agent.users[0].username}}</td>-->
<!--                      <td v-else >null</td>-->
<!--                    <td>{{agent.email}}</td>-->
<!--                    <td>{{agent.phone_code}} {{agent.phone_number}}</td>-->
<!--                      <td><button @click.prevent="approveAgent(agent)" class="btn btn-primary btn-small"><i class="fas fa-edit"></i>Approve</button> </td>-->
<!--                      <td><router-link :to="{ name: 'agent_update', params: {type:'reject',uuid: agent.uuid } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link></td>-->
<!--                    <td> <button @click.prevent="deleteWarning(agent)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>-->

<!--                  </tr>-->
<!--                </tbody>-->
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
table>tr>td{
    width:30%;
    height:30px;
}
.margin-5px{
    margin-right: 5px;
}
.width-20px{
    table-layout: fixed;
    width: 20px;
}
.padding-5px{
    padding-right: 3%;
    padding-left: 3%;
}
/*.padding-5px-right{*/
/*    word-break: break-all;*/
/*    overflow: auto;*/
/*}*/
.table-responsive img{
    width:60px;
}
table>tr>td:nth-child(odd) {
    font-weight: 600;
}
</style>
